/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface FormateurPrestationsGlobalesSearch
 */
export interface FormateurPrestationsGlobalesSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    idformateur?: number;
    /**
     * 
     * @type {string}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    annee?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurPrestationsGlobalesSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurPrestationsGlobalesSearch interface.
 */
export function instanceOfFormateurPrestationsGlobalesSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurPrestationsGlobalesSearchFromJSON(json: any): FormateurPrestationsGlobalesSearch {
    return FormateurPrestationsGlobalesSearchFromJSONTyped(json, false);
}

export function FormateurPrestationsGlobalesSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurPrestationsGlobalesSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'annee': !exists(json, 'annee') ? undefined : json['annee'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurPrestationsGlobalesSearchToJSON(value?: FormateurPrestationsGlobalesSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateur': value.idformateur,
        'annee': value.annee,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

